import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class FertilizerMedicineService {
  constructor(private commonService: CommonService) { }

  getAll(langId: string = '',pageIndex: number = Pagination.PageIndex, pageSize: number = Pagination.PageSize): Observable<ResponseResult> {
    return this.commonService.getAll(`fertilizer-medicine`, false, pageSize, pageIndex, langId);
  }

  create(model): Observable<ResponseResult> {
    return this.commonService.createData(`fertilizer-medicine`, model, model.langId, model.parentId);
  }

  update(model): Observable<ResponseResult> {
    return this.commonService.updateData(`fertilizer-medicine/${model.id}`, model);
  }

  delete(id): Observable<ResponseResult> {
    return this.commonService.deleteData(`fertilizer-medicine/${id}`);
  }
}
